import { Gavel } from "@mui/icons-material"
import { termsAndCondition } from "../../data/shmoozPolicies"
import { lastUpdatedPolicyDate, companyName, companyEmail, companyPhone, companyAddress } from "../../app/store/constant"
import { H3, H2, H5, Body2 } from "../../themes/typography"
import "../../styles/saas-pages/TermsAndConditions.css"

export default function TermsAndCondition() {
    return (
        <div className="page-view">
            <div className="page-wrapper">

                <div className="terms-container">
                    <div className="terms-wrapper">

                        <div className="terms-icon-container">
                            <Gavel color="tertiary" sx={{ fontSize: '3rem' }} />
                        </div>

                        <div className="content-container">

                            <header className="terms-header">
                                <H2 fontWeight={700}>
                                    Terms and Conditions
                                </H2>

                                <Body2 color="var(--secondary-color)">
                                    {`Last updated: ${lastUpdatedPolicyDate}`}
                                </Body2>

                                <H3 color="var(--tertiary-color)" fontWeight={600}>
                                    {companyName}
                                </H3>
                            </header>

                            <main className="terms-content">
                                <section className="terms-section">
                                    <Body2>
                                        Welcome to Shmooz, a platform operated by {companyName} (“Shmooz”, “We”, “Us”, “Our”). These Terms & Conditions (“Terms”) govern your use of the Shmooz website, mobile application, and services (together, the “Platform”).
                                    </Body2>

                                    <Body2>
                                        By registering, accessing, or using the Platform, you (“User”, “You”) agree to these Terms. If you do not agree, please discontinue use.
                                    </Body2>
                                </section>

                                {termsAndCondition.map((term) => (
                                    <section className="terms-section" key={term.id}>
                                        <H5 color="var(--secondary-color)" fontWeight={700}>
                                            {term.id}. {term.title}
                                        </H5>

                                        {term.type === "text" && typeof term.content === "string" && (
                                            <Body2>{term.content}</Body2>
                                        )}

                                        {term.type === "text" && Array.isArray(term.content) && (
                                            <>
                                                {term.content.map((point, index) => (
                                                    <Body2 key={index}>
                                                        {point}
                                                    </Body2>
                                                ))}
                                            </>
                                        )}

                                        {term.type === "list" && Array.isArray(term.content) && (
                                            <ul className="terms-list">
                                                {term.content.map((point, index) => (
                                                    <Body2 key={index}>
                                                        <li>{point}</li>
                                                    </Body2>
                                                ))}
                                            </ul>
                                        )}

                                        {term.type === "contact" && term.contact && (
                                            <div className="contact-info">
                                                <Body2 color="var(--tertiary-color)">
                                                    <strong>
                                                        {companyName}
                                                    </strong>
                                                </Body2>
                                                {term.contact.address && (
                                                    <Body2>
                                                        Address : {companyAddress}
                                                    </Body2>
                                                )}
                                                {term.contact.email && (
                                                    <Body2>
                                                        Email : <a href={`mailto:${companyEmail}`} style={{ textDecoration: 'underline', color: 'var(--tertiary-color)' }}>{companyEmail}</a>
                                                    </Body2>
                                                )}
                                                {term.contact.phone && (
                                                    <Body2>
                                                        Phone : <a href={`tel:${companyPhone}`} style={{ textDecoration: 'underline', color: 'var(--tertiary-color)' }}>{companyPhone}</a>
                                                    </Body2>
                                                )}
                                            </div>
                                        )}
                                    </section>
                                ))}
                            </main>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}